export default {"src":"/_next/static/media/finance_chart.9112ceea.svg","height":20,"width":24,"blurWidth":0,"blurHeight":0};